import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";





import { PrimaryUser } from "../../../../auth/types/models/User";

import UserFormSelect from "../../../../auth/components/user/UserForm/UserFormSelect";



import MembersGroupFormSelect from "../../../../auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect";















import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";















export const initialFormStateFn = () => { return {
    
        
        userId: null,
        
    
        
        userGroupId: null,
        
    
        
        refreshToken: "",
        
    
        
        device: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.userId = PrimaryUser.fromQuery(location.state?.userId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        userId:
        string()
                .nanoid(msg`User is required`)
                .min(1, msg`User is required`),
    
    
        userGroupId:
        string()
                .nanoid(msg`User Group is required`)
                .min(1, msg`User Group is required`),
    
    
        refreshToken:
        string()
        .trim()
        .min(1, msg`Refresh Token is required`),
    
    
        device:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const UserSessionAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <UserFormSelect
        type="dynamicSelect"
        name="userId"
        label={t`User`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <MembersGroupFormSelect
        type="dynamicSelect"
        name="userGroupId"
        label={t`User Group`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'refreshToken' }
       aria-label="refreshToken"
       data-testid="refreshToken"
       label={t`Refresh Token`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'device' }
       aria-label="device"
       data-testid="device"
       label={t`Device`}
       
       type='text'
       
   />
   
   
           
        </Container>
    )
}

export default UserSessionAddForm;
